<template>
  <div class="w con">
    <con-title>{{ articleDetail.title }}</con-title>
    <div>
      <div class="des">{{ articleDetail.description }}</div>
      <div class="time">{{ articleDetail.createTime }}</div>
      <div class="content" v-html="articleDetail.content"></div>
    </div>
  </div>
</template>

<script>
import { articleDetail } from '@/api/article'
export default {
  data() {
    return { id: '', articleDetail: '' }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    }
    this.loadData()
  },
  methods: {
    async loadData() {
      var params = {
        id: this.id
      }
      const { data } = await articleDetail(params)
      this.articleDetail = data.info
    }
  }
}
</script>

<style lang="scss" scoped>
.des {
  text-align: center;
  margin-bottom: 20px;
}
.time {
  font-size: 13px;
  text-align: center;
  margin-bottom: 20px;
  color: #888;
}
.con {
  margin-bottom: 20px;
}
</style>

<style lang="scss">
img {
  // width: auto;
  height: auto;
}
.content img {
  max-width: 100%;
}
</style>
